module.exports = __webpack_public_path__ + "static/media/church-domes.0f87e323.jpg";